import * as React from "react";
import { Platform } from "react-native";

import SafeHorizontal from "../safe-horizontal";

export default function ModalPadding({ children }: { children: any }) {
  return (
    <SafeHorizontal
      sx={{
        px: Platform.select({ default: "$2", web: ["$2", "$4"] as any }),
        pb: Platform.select({ default: "$2", web: ["$2", "$4"] as any }),
      }}
    >
      {children}
    </SafeHorizontal>
  );
}
